import React, { useRef, useEffect } from "react";
import { TextField } from "@mui/material";

const CustomNumberInput = (props) => {
  const {
    label,
    value,
    onChange,
    name,
    disable,
    isLock = false,
    isReadOnly = false,
    isLabel = false,
    minValue = false,
    maxValue = false,
    MinMaxAlert = false,
    sx = {},
    ...rest
  } = props;

  const inputRef = useRef(null);

  useEffect(() => {
    const input = inputRef.current?.querySelector("input");
    if (input) {
      const handleWheel = (e) => {
        if (document.activeElement === input) {
          e.preventDefault();
        }
      };
      input.addEventListener("wheel", handleWheel, { passive: false });
      return () => input.removeEventListener("wheel", handleWheel);
    }
  }, []);

  const handleChange = (e) => {
    const newValue = e.target.value;
    const parsedValue = newValue !== "" ? Number(newValue) : "";

    if (parsedValue !== "" && !MinMaxAlert) {
      if (minValue !== false && parsedValue < minValue) return;
      if (maxValue !== false && parsedValue > maxValue) return;
    }

    onChange(e);
  };

  const checkMinMaxAlert = () => {
    if ([undefined, null, ""].includes(value)) return false;
    return Number(value) < Number(minValue) || Number(value) > Number(maxValue);
  };

  return (
    <TextField
      fullWidth
      type="number"
      variant="outlined"
      label={isLock ? "Lock" : isLabel ? label : null}
      name={name}
      value={value}
      onChange={handleChange}
      InputProps={{
        readOnly: isReadOnly || isLock,
        inputProps: {
          ...(!MinMaxAlert
            ? {
                min: minValue,
                max: maxValue,
              }
            : {}),
        },
      }}
      disabled={disable || isLock}
      sx={{
        ...(MinMaxAlert &&
          checkMinMaxAlert() && {
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "error.main",
              },
              "&:hover fieldset": {
                borderColor: "error.dark",
              },
              "&.Mui-focused fieldset": {
                borderColor: "error.dark",
              },
            },
          }),
        ...sx,
      }}
      {...rest}
      ref={inputRef}
    />
  );
};

export default CustomNumberInput;
